/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const artistPages = {
    ArtistDetailPage: () => import('@/artist/ArtistDetailPage'),
    ArtistAllAccessSongsPage: () => import('@/artist/ArtistAllAccessSongsPage'),
    ArtistChronologicalAlbumsPage: () => import('@/artist/ArtistChronologicalAlbumsPage'),
    ArtistFanPollPage: () => import('@/artist/ArtistFanPollPage'),
    ArtistPopularAlbumsPage: () => import('@/artist/ArtistPopularAlbumsPage'),
    ArtistPopularSongsPage: () => import('@/artist/ArtistPopularSongsPage'),
    ArtistPopularVideosPage: () => import('@/artist/ArtistPopularVideosPage'),
    ArtistRelatedArtistsPage: () => import('@/artist/ArtistRelatedArtistsPage'),
    ArtistRelatedPlaylistsPage: () => import('@/artist/ArtistRelatedPlaylistsPage'),
    ArtistRelatedPodcastsPage: () => import('@/artist/ArtistRelatedPodcastsPage'),
    ArtistRelatedStationsPage: () => import('@/artist/ArtistRelatedStationsPage'),
}
